module.exports = __webpack_public_path__ + "img/q_popup.b65f71e2.gif";